import React from 'react'
import VendorWrapper from '../VendorWrapper'
import VendorNavItem from './VendorNavItem'
import { BarChartOutlined, CopyrightOutlined, InfoOutlined, NotificationsNoneOutlined, RequestQuoteOutlined, SummarizeOutlined, TrackChangesOutlined, TrendingUpOutlined } from '@mui/icons-material'
import { useTranslation } from 'react-i18next'
import { NavItemsProps } from '../../Layout/NavItem'
import { Collapse } from '@mui/material'

const VendorNavItems: React.FC<NavItemsProps> = (props) => {
  const { t } = useTranslation("menu")
  const [openDownload, setOpenDownload] = React.useState(false);
  const [openGoal, setOpenGoal] = React.useState(false);

  const handleDownloadClick = () => {
    setOpenDownload(!openDownload);
  };

  const handleGoalClick = () => {
    setOpenGoal(!openGoal);
  };


  return <VendorWrapper>
    <VendorNavItem
      uri='clients'
      title={t('clients')}
      icon='people'
      {...props}
    />

    <VendorNavItem
      uri='notifications'
      title={t('notifications')}
      icon={<NotificationsNoneOutlined />}
      {...props}
    />

    <VendorNavItem
      uri='goals'
      title={t('goals')}
      icon={<TrackChangesOutlined />}
      nested
      onClick={handleGoalClick}
      openItem={openGoal}
      {...props}
    />

    <Collapse in={openGoal} timeout="auto" style={{
      marginTop: openGoal ? props.open ? "-16px" : "-6px" : "0px",
      marginBottom: openGoal ? props.open ? "-16px" : "-6px" : "-16px"
    }}>
      <VendorNavItem
        uri='goals-stats-client'
        title={t('clientGoals')}
        icon={<BarChartOutlined />}
        subItem
        {...props}
      />
      <VendorNavItem
        uri='goals-stats-vendor'
        title={t('vendorGoals')}
        icon={<TrendingUpOutlined />}
        subItem
        {...props}
      />
      {/*
      <VendorNavItem
        uri='vendorClientBrandMatrix'
        title={t('brandGoals')}
        icon={<CopyrightOutlined />}
        subItem
        {...props}
      />*/}

    </Collapse>

    <VendorNavItem
      uri='downloads'
      title={t('downloadReport')}
      nested
      icon={<InfoOutlined />}
      onClick={handleDownloadClick}
      openItem={openDownload}
      {...props}
    />

    <Collapse in={openDownload} timeout="auto" style={{
      marginTop: openDownload ? props.open ? "-16px" : "-6px" : "0px",
      marginBottom: openDownload ? props.open ? "-16px" : "-6px" : "-16px"
    }}>
      <VendorNavItem
        uri='dlPriceList'
        title={t('priceList')}
        icon={<RequestQuoteOutlined />}
        subItem
        {...props}
      />

      <VendorNavItem
        uri='currentAccountSummary'
        title={t('currentAccountSummary')}
        icon={<SummarizeOutlined />}
        subItem
        {...props}
      />

    </Collapse>


  </VendorWrapper>
}

export default VendorNavItems

/*            
<Divider />

<VendorNavItem
  uri='profile'
  title={t('profile')}
  icon='person'
/>

*/